import createSagaMiddleware from 'redux-saga';
import { take, all, cancel } from 'redux-saga/effects';


export const sagaMiddleware = createSagaMiddleware();

const ABORT_SAGAS_HMR = 'ABORT_SAGAS_HMR';

export const createRootSaga = ({ sagas }) => {
    if (process.env.NODE_ENV === 'development') {
        return function* main() {
            yield all(sagas);

            yield take(ABORT_SAGAS_HMR);
            yield cancel();
        };
    }

    return function* main() {
        yield all(sagas);
    };
};

export const abortSagas = store => store.dispatch({ type: ABORT_SAGAS_HMR });
